// Storage key enum for localStorage and sessionStorage keys.
// One enum for both, since some values use different storage type,
// depending on the "remember me" functionality.
export enum StorageKey {
  LogLevel = "logLevel",
  GuestName = "guestName",
  TestToolHidden = "testToolHidden",
  KeycloakToken = "keycloak_",
}
